export default {
      id: "gas-station-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#gas-station",
      toString: function () {
        return this.url;
      }
    }